import { object, string, TypeOf } from 'yup';

export const ListCompanyTemplateFilterSchema = object({
  code: string(),
});

export type ListCompanyTemplateFilterType = TypeOf<
  typeof ListCompanyTemplateFilterSchema
>;
